/*=============================================== MarkdownEditorPage ===============================================*/

import { useState } from "react"
import { MarkdownEditor } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    commonProps,
    inputLabel,
    inputBackgroundColor,
    iconBoxicon,
} from "data"

const MarkdownEditorPage = () => {
    const [body, setBody] = useState<string>("")

    const items: ItemType[] = [
        {
            content: (
                <MarkdownEditor
                    value={body}
                    setValue={setBody}
                    label="Markdown editor"
                />
            ),
            code: 'const [body, setBody] = useState("")\n\n<MarkdownEditor value={body} setValue={setBody} label="Markdown editor" />',
            codeTs: 'const [body, setBody] = useState<string>("")\n\n<MarkdownEditor value={body} setValue={setBody} label="Markdown editor" />',
        },
    ]

    const buttonNames: string[] = [
        "bold",
        "italic",
        "strikethrough",
        "ul",
        "ol",
        "link",
        "quote",
        "hr",
        "code",
        "codeBlock",
        "comment",
        "image",
        "editorCode",
        "editorLive",
        "editorPreview",
    ]

    const showButtonProps = buttonNames.map(button => {
        const ab: PropsItemType = {
            subtitle: button,
            type: "boolean",
            default: "true",
        }
        return ab
    })

    const propsItems: PropsItemType[] = [
        {
            subtitle: "value",
            type: "string",
            required: true,
        },
        {
            subtitle: "setValue",
            type: "function",
            required: true,
        },
        {
            subtitle: "counter",
            type: "boolean",
        },
        {
            subtitle: "maxLength",
            type: "number",
        },
        inputBackgroundColor(),
        {
            subtitle: "defaultEditor",
            intro: "What the components displays by default.",
            type: "string",
            possible: ["editorCode", "editorLive", "editorPreview"],
            default: "editorLive",
        },
        ...inputLabel(),
        "separator",
        {
            subtitle: "showButtons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>showButtons</code> object
                </>
            ),
            subtitle: "titles",
            type: "boolean",
            default: "true",
        },
        ...showButtonProps,
        "separator",
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "bold",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("bold"),
        },
        {
            subtitle: "italic",
            type: "string",
            default: iconBoxicon("italic"),
        },
        {
            subtitle: "strikethrough",
            type: "string",
            default: iconBoxicon("strikethrough"),
        },
        {
            subtitle: "ul",
            type: "string",
            default: iconBoxicon("list-ul"),
        },
        {
            subtitle: "ol",
            type: "string",
            default: iconBoxicon("list-ol"),
        },
        {
            subtitle: "link",
            type: "string",
            default: iconBoxicon("link"),
        },
        {
            subtitle: "quote",
            type: "string",
            default: iconBoxicon("quoquote-alt-leftte"),
        },
        {
            subtitle: "hr",
            type: "string",
            default: <>Own icon</>,
        },
        {
            subtitle: "code",
            type: "string",
            default: iconBoxicon("code"),
        },
        {
            subtitle: "codeBlock",
            type: "string",
            default: iconBoxicon("code-block"),
        },
        {
            subtitle: "comment",
            type: "string",
            default: iconBoxicon("message-dots"),
        },
        {
            subtitle: "image",
            type: "string",
            default: iconBoxicon("image"),
        },
        {
            subtitle: "editorCode",
            type: "string",
            default: <>Own icon</>,
        },
        {
            subtitle: "editorLive",
            type: "string",
            default: <>Own icon</>,
        },
        {
            subtitle: "editorPreview",
            type: "string",
            default: <>Own icon</>,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default MarkdownEditorPage
